export default (n: number | null | undefined, decimalFactor = 10) => {
  if (n == null || n == undefined) {
    return "";
  }
  return Math.round(n * 100 * decimalFactor) / decimalFactor + "%";
};
